<template>
  <div class="aps">
    <div class="aps-head">
      <div class="aps-head-icon"><i class="fa fa-mobile"></i></div>
      <div class="aps-head-text">
        <h4>إعدادات تطبيق ولي الأمر</h4>
        <p>كل ما تغيّره هنا يظهر لأولياء الأمور في التطبيق بعد الضغط على «حفظ الإعدادات».</p>
      </div>
      <button v-if="checkPer('students|students|view')" type="button" class="btn btn-outline-primary aps-head-btn" @click="loadApp()" v-b-modal.app-status>
        <i class="fa fa-users"></i> من حمّل التطبيق ومن لم يحمّله
      </button>
    </div>

    <div class="text-center g" v-if="!loaded">
      <img :src="require('@/assets/images/loading.svg')" alt="" width="50">
    </div>

    <div class="row" v-else>
      <div class="col-12 col-xl-7">
        <!-- موعد الخروج: نفس الموعد كل يوم / موعد لكل يوم / إخفاء، + استثناءات بالتاريخ (Option app_settings dismissal_*) -->
        <section class="aps-card">
          <header>
            <span class="aps-ic red"><i class="fa fa-clock-o"></i></span>
            <div class="aps-title">
              <h5>موعد الخروج للطلاب</h5>
              <small>يظهر لولي الأمر في الرئيسية: «موعد الخروج اليوم».</small>
            </div>
            <label v-if="settings.dismissal_mode == 'fixed'" class="aps-switch" :class="{ disabled: !settings.dismissal_time }" title="إظهار في التطبيق">
              <input type="checkbox" :checked="settings.dismissal_show == 'yes'" :disabled="!settings.dismissal_time" @change="set('dismissal_show', $event.target.checked ? 'yes' : false)">
              <span></span>
              <b>{{ settings.dismissal_show == 'yes' && settings.dismissal_time ? 'ظاهر' : 'مخفي' }}</b>
            </label>
          </header>
          <div class="aps-body">
            <div class="dmode" role="radiogroup" aria-label="طريقة عرض موعد الخروج">
              <button v-for="m in dismissalModes" :key="m.key" type="button" role="radio" class="dmode-btn" :class="{ on: settings.dismissal_mode == m.key }" :aria-checked="settings.dismissal_mode == m.key" @click="setMode(m.key)">
                <i class="fa" :class="m.icon"></i>
                <b>{{ m.title }}</b>
                <small>{{ m.hint }}</small>
              </button>
            </div>

            <template v-if="settings.dismissal_mode == 'fixed'">
              <div class="dismissal">
                <div class="dismissal-field">
                  <label for="dismissal-time">وقت الخروج</label>
                  <input id="dismissal-time" type="time" class="form-control" :value="settings.dismissal_time" @input="setTime($event.target.value)">
                </div>
                <div class="quick">
                  <span>اختيار سريع:</span>
                  <button v-for="t in quickTimes" :key="t" type="button" class="chip" :class="{ on: settings.dismissal_time == t }" @click="setTime(t)">{{ time12(t) }}</button>
                  <button v-if="settings.dismissal_time" type="button" class="chip clear" @click="setTime('')"><i class="fa fa-times"></i> إلغاء الموعد</button>
                </div>
              </div>
              <small class="text-muted d-block mt-50">يظهر من الأحد إلى الخميس فقط، ولا يظهر في الجمعة والسبت.</small>
            </template>

            <template v-if="settings.dismissal_mode == 'weekly'">
              <div class="dweek">
                <div class="dday" v-for="d in weekDays" :key="d.key" :class="{ off: !settings.dismissal_days[d.key] }">
                  <span class="dday-name">{{ d.title }}</span>
                  <input type="time" class="form-control" :aria-label="'وقت الخروج يوم ' + d.title" :value="settings.dismissal_days[d.key]" @input="setDay(d.key, $event.target.value)">
                  <button type="button" class="chip" :class="{ on: !settings.dismissal_days[d.key] }" @click="setDay(d.key, '')">لا يظهر</button>
                  <span class="dday-12" v-if="settings.dismissal_days[d.key]">{{ time12(settings.dismissal_days[d.key]) }}</span>
                </div>
                <button type="button" class="dmore" @click="showOtherDays = !showOtherDays" :aria-expanded="showOtherDays || otherDaysSet">
                  <i class="fa" :class="showOtherDays || otherDaysSet ? 'fa-angle-up' : 'fa-angle-down'"></i> أيام أخرى (الجمعة والسبت)
                </button>
                <template v-if="showOtherDays || otherDaysSet">
                  <div class="dday" v-for="d in otherDays" :key="d.key" :class="{ off: !settings.dismissal_days[d.key] }">
                    <span class="dday-name">{{ d.title }}</span>
                    <input type="time" class="form-control" :aria-label="'وقت الخروج يوم ' + d.title" :value="settings.dismissal_days[d.key]" @input="setDay(d.key, $event.target.value)">
                    <button type="button" class="chip" :class="{ on: !settings.dismissal_days[d.key] }" @click="setDay(d.key, '')">لا يظهر</button>
                    <span class="dday-12" v-if="settings.dismissal_days[d.key]">{{ time12(settings.dismissal_days[d.key]) }}</span>
                  </div>
                </template>
                <div class="quick mt-50" v-if="settings.dismissal_days.Sunday">
                  <button type="button" class="chip" @click="copySunday()"><i class="fa fa-clone"></i> نسخ وقت الأحد لباقي أيام الأسبوع</button>
                </div>
              </div>
            </template>

            <p class="dnote" v-if="settings.dismissal_mode == 'off'">
              <i class="fa fa-eye-slash"></i> لن يظهر «موعد الخروج اليوم» في تطبيق ولي الأمر، إلا في التواريخ المستثناة أدناه.
            </p>

            <!-- استثناءات بالتاريخ -->
            <div class="dex-head">
              <div>
                <b>استثناءات بتاريخ</b>
                <small>أيام لها موعد مختلف أو بلا موعد (اختبارات، رمضان، مناسبات). تتقدّم على ما سبق.</small>
              </div>
              <button type="button" class="btn btn-sm btn-outline-primary" @click="addException()" :disabled="settings.dismissal_dates.length >= 120"><i class="fa fa-plus"></i> إضافة تاريخ</button>
            </div>
            <div class="dex" v-for="(x, i) in settings.dismissal_dates" :key="i" :class="{ past: x.date && x.date < today }">
              <div class="dex-f">
                <label :for="'dex-date-' + i">التاريخ</label>
                <input :id="'dex-date-' + i" type="date" class="form-control" v-model="x.date">
                <small class="text-muted">{{ dayTitle(x.date) }}{{ x.date && x.date < today ? ' — انتهى' : '' }}</small>
              </div>
              <div class="dex-f">
                <label>في هذا اليوم</label>
                <div class="dex-seg">
                  <button type="button" :class="{ on: !!x.time }" @click="exceptionTime(x, true)">موعد</button>
                  <button type="button" :class="{ on: !x.time }" @click="exceptionTime(x, false)">إخفاء</button>
                </div>
              </div>
              <div class="dex-f" v-if="x.time">
                <label :for="'dex-time-' + i">الوقت</label>
                <input :id="'dex-time-' + i" type="time" class="form-control" v-model="x.time">
              </div>
              <div class="dex-f grow">
                <label :for="'dex-note-' + i">ملاحظة (اختياري)</label>
                <input :id="'dex-note-' + i" type="text" class="form-control" maxlength="60" v-model="x.note" placeholder="مثال: اختبارات نهاية الفصل">
              </div>
              <button type="button" class="icon-btn danger" title="حذف التاريخ" @click="settings.dismissal_dates.splice(i, 1)"><i class="fa fa-trash"></i></button>
            </div>
            <p class="empty" v-if="!settings.dismissal_dates.length">لا توجد استثناءات.</p>
            <a href="javascript:;" class="small text-danger" v-if="pastExceptions" @click="removePastExceptions()">حذف التواريخ المنتهية ({{ pastExceptions }})</a>

            <label class="aps-row mt-50">
              <span>إخفاء الموعد في أيام الإجازات <small>الأيام المسجلة في «أيام الإجازات» لا يظهر فيها موعد.</small></span>
              <span class="aps-switch"><input type="checkbox" :checked="settings.dismissal_skip_holidays != 'no'" @change="set('dismissal_skip_holidays', $event.target.checked ? 'yes' : 'no')"><span></span></span>
            </label>
            <div class="dismissal-note">
              <label for="dismissal-note">ملاحظة تظهر مع الموعد <small class="text-muted">(اختياري — {{ (settings.dismissal_note || '').length }}/60)</small></label>
              <input id="dismissal-note" type="text" class="form-control" maxlength="60" v-model="settings.dismissal_note" placeholder="مثال: الخروج من البوابة الشرقية">
            </div>

            <div class="preview">
              <span class="preview-label">اليوم ({{ dayTitle(today) }}) في تطبيق ولي الأمر:</span>
              <span v-if="todayPill.time" class="dismissal-chip">
                <i class="fa fa-clock-o"></i> موعد الخروج اليوم <b>{{ time12(todayPill.time) }}</b>
              </span>
              <span v-else class="text-muted">لن يظهر شيء — {{ todayPill.why }}.</span>
              <small v-if="todayPill.time && todayPill.note" class="preview-note">{{ todayPill.note }}</small>
              <small class="preview-src" v-if="todayPill.src">{{ todayPill.src }}</small>
            </div>
          </div>
        </section>

        <!-- الأخبار والتنبيهات -->
        <section class="aps-card">
          <header>
            <span class="aps-ic blue"><i class="fa fa-bullhorn"></i></span>
            <div class="aps-title">
              <h5>الأخبار والتنبيهات <span class="count" v-if="settings.ads.length">{{ settings.ads.length }}</span></h5>
              <small>تظهر في الرئيسية في التطبيق، والخبر الهام يظهر كنافذة منبثقة.</small>
            </div>
            <button class="btn btn-primary btn-sm" @click="addAd()"><i class="fa fa-plus"></i> إضافة خبر</button>
          </header>
          <div class="aps-body">
            <div class="notify" v-if="newAd" :class="{ on: sendNotification }">
              <label class="aps-switch">
                <input type="checkbox" v-model="sendNotification">
                <span></span>
              </label>
              <div>
                <b>أرسل إشعاراً لأولياء الأمور بهذا الخبر عند الحفظ</b>
                <small class="d-block">عنوان الإشعار: «{{ newAd.title || 'خبر جديد' }}» — يصل لمن حمّل التطبيق.</small>
              </div>
            </div>

            <p class="empty" v-if="!settings.ads.length">لا توجد أخبار. اضغط «إضافة خبر» لإضافة أول خبر.</p>

            <div class="ad" v-for="ad in settings.ads" :key="ad.id" :class="{ fresh: isNew(ad) }">
              <div class="ad-top">
                <span class="badge-new" v-if="isNew(ad)">جديد</span>
                <input type="text" :id="'ad-title-' + ad.id" placeholder="عنوان الخبر" v-model="ad.title" class="form-control ad-title">
                <button class="icon-btn danger" title="حذف الخبر" @click="removeAd(ad)"><i class="fa fa-trash"></i></button>
              </div>
              <textarea :id="'ad-content-' + ad.id" rows="2" placeholder="التفاصيل..." v-model="ad.content" class="form-control"></textarea>

              <div class="ad-row">
                <div class="ad-image">
                  <img v-if="ad.image" :src="ad.image" alt="">
                  <label class="btn btn-sm btn-outline-secondary mb-0">
                    <i class="fa fa-image"></i> {{ ad.image ? 'تغيير الصورة' : 'إضافة صورة (اختياري)' }}
                    <input type="file" accept="image/*" hidden @change="uploadImage($event, ad)">
                  </label>
                  <a v-if="ad.image" href="javascript:;" class="text-danger small" @click="ad.image = ''">إزالة</a>
                </div>
                <label class="aps-switch small-sw" title="يظهر كنافذة منبثقة في الرئيسية، ويمكن لولي الأمر إغلاقها">
                  <input type="checkbox" v-model="ad.important">
                  <span></span>
                  <b>خبر هام (نافذة منبثقة)</b>
                </label>
              </div>

              <div class="ad-row">
                <div class="ad-action">
                  <label :for="'ad-do-' + ad.id">عند الضغط على الخبر</label>
                  <select :id="'ad-do-' + ad.id" class="form-control" v-model="ad.whatdo">
                    <option :value="undefined">لا شيء</option>
                    <option value="whatsapp">فتح محادثة واتساب</option>
                    <option value="link">فتح رابط</option>
                  </select>
                </div>
                <div class="ad-action" v-if="ad.whatdo == 'whatsapp'">
                  <label :for="'ad-phone-' + ad.id">رقم الواتساب (بالصيغة الدولية)</label>
                  <input :id="'ad-phone-' + ad.id" type="number" class="form-control ltr" v-model="ad.phone" placeholder="966503332...">
                </div>
                <div class="ad-action" v-if="ad.whatdo == 'link'">
                  <label :for="'ad-link-' + ad.id">الرابط</label>
                  <input :id="'ad-link-' + ad.id" type="url" class="form-control ltr" v-model="ad.link" placeholder="https://...">
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- طلبات أولياء الأمور (Option parent_requests: /user/students/requests/settings) -->
        <section class="aps-card" id="parent-requests">
          <header>
            <span class="aps-ic amber"><i class="fa fa-inbox"></i></span>
            <div class="aps-title">
              <h5>طلبات أولياء الأمور</h5>
              <small>طلب استئذان أو زيارة يرسله ولي الأمر من التطبيق، ويصل المدرسة في «طلبات الاستئذان» و«طلبات الزيارة».</small>
            </div>
          </header>
          <div class="aps-body" v-if="!pr.supported">
            <p class="empty">{{ pr.loading ? 'جاري التحميل...' : 'إعدادات الطلبات غير متاحة حالياً.' }}</p>
          </div>
          <div class="aps-body" v-else>
            <div class="prs">
              <label class="aps-row prs-head">
                <span><b><i class="fa fa-sign-out"></i> طلبات الاستئذان</b> <small>ولي الأمر يطلب خروج ابنه ويكتب السبب، والمدرسة توافق أو ترفض.</small></span>
                <span class="aps-switch"><input type="checkbox" v-model="pr.s.leave.enabled"><span></span></span>
              </label>
              <div class="prs-body" v-if="pr.s.leave.enabled">
                <div class="prs-grid">
                  <div class="prs-f">
                    <label for="pr-leave-from">يُسمح بالإرسال من الساعة</label>
                    <input id="pr-leave-from" type="time" class="form-control" v-model="pr.s.leave.from">
                  </div>
                  <div class="prs-f">
                    <label for="pr-leave-to">إلى الساعة</label>
                    <input id="pr-leave-to" type="time" class="form-control" v-model="pr.s.leave.to">
                  </div>
                  <div class="prs-f">
                    <label for="pr-leave-ahead">الطلب مسبقاً حتى (أيام)</label>
                    <input id="pr-leave-ahead" type="number" min="0" max="30" class="form-control" v-model.number="pr.s.leave.days_ahead">
                  </div>
                </div>
                <small class="prs-hint">اترك الوقت فارغاً للسماح في أي وقت. «0» = لليوم فقط.
                  <a href="javascript:;" v-if="pr.s.leave.from || pr.s.leave.to" @click="pr.s.leave.from = ''; pr.s.leave.to = ''">أي وقت</a></small>
                <div class="aps-sub">محدد مسبقاً عند الموافقة</div>
                <label class="aps-row" v-for="o in leaveOptions" :key="o.key">
                  <span>{{ o.title }} <small>{{ o.hint }}</small></span>
                  <span class="aps-switch"><input type="checkbox" v-model="pr.s.leave.approve_defaults[o.key]"><span></span></span>
                </label>
                <div class="prs-grid two">
                  <div class="prs-f">
                    <label for="pr-leave-ok">رد تلقائي عند الموافقة</label>
                    <textarea id="pr-leave-ok" rows="2" maxlength="500" class="form-control" v-model="pr.s.leave.auto_note_approve" placeholder="مثال: تمت الموافقة، يرجى الحضور إلى البوابة الرئيسية."></textarea>
                  </div>
                  <div class="prs-f">
                    <label for="pr-leave-no">رد تلقائي عند الرفض</label>
                    <textarea id="pr-leave-no" rows="2" maxlength="500" class="form-control" v-model="pr.s.leave.auto_note_reject" placeholder="مثال: نعتذر، يرجى التواصل مع وكيل شؤون الطلاب."></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="prs">
              <label class="aps-row prs-head">
                <span><b><i class="fa fa-calendar-check-o"></i> طلبات الزيارة</b> <small>ولي الأمر يحدد يوم الزيارة وغرضها، والمدرسة توافق أو تقترح موعداً آخر.</small></span>
                <span class="aps-switch"><input type="checkbox" v-model="pr.s.visit.enabled"><span></span></span>
              </label>
              <div class="prs-body" v-if="pr.s.visit.enabled">
                <div class="prs-grid">
                  <div class="prs-f">
                    <label for="pr-visit-min">بعد (أيام) على الأقل</label>
                    <input id="pr-visit-min" type="number" min="0" max="365" class="form-control" v-model.number="pr.s.visit.min_days">
                  </div>
                  <div class="prs-f">
                    <label for="pr-visit-max">وحتى (أيام) على الأكثر</label>
                    <input id="pr-visit-max" type="number" min="0" max="365" class="form-control" v-model.number="pr.s.visit.max_days">
                  </div>
                  <div class="prs-f">
                    <label for="pr-visit-from">الزيارة من الساعة</label>
                    <input id="pr-visit-from" type="time" class="form-control" v-model="pr.s.visit.from">
                  </div>
                  <div class="prs-f">
                    <label for="pr-visit-to">إلى الساعة</label>
                    <input id="pr-visit-to" type="time" class="form-control" v-model="pr.s.visit.to">
                  </div>
                </div>
                <small class="prs-hint">«0» = يمكن طلب زيارة لليوم نفسه.</small>
                <div class="aps-sub">أيام الزيارة</div>
                <div class="prs-days">
                  <button v-for="d in allDays" :key="d.key" type="button" class="chip" :class="{ on: (pr.s.visit.days || []).indexOf(d.key) > -1 }" :aria-pressed="(pr.s.visit.days || []).indexOf(d.key) > -1" @click="toggleVisitDay(d.key)">{{ d.title }}</button>
                </div>
                <div class="prs-grid two">
                  <div class="prs-f">
                    <label for="pr-visit-ok">رد تلقائي عند الموافقة</label>
                    <textarea id="pr-visit-ok" rows="2" maxlength="500" class="form-control" v-model="pr.s.visit.auto_note_approve" placeholder="مثال: مرحباً بكم، يرجى إحضار الهوية."></textarea>
                  </div>
                  <div class="prs-f">
                    <label for="pr-visit-no">رد تلقائي عند الرفض</label>
                    <textarea id="pr-visit-no" rows="2" maxlength="500" class="form-control" v-model="pr.s.visit.auto_note_reject" placeholder="مثال: الموعد غير مناسب، نأمل اختيار موعد آخر."></textarea>
                  </div>
                </div>
              </div>
            </div>
            <small class="text-muted d-block">من له صلاحية «طلبات الاستئذان» أو «طلبات الزيارة» يصله إشعار بكل طلب جديد، ويظهر العدد في القائمة الجانبية.</small>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-5">
        <!-- إضافة الطلاب -->
        <section class="aps-card">
          <header>
            <span class="aps-ic green"><i class="fa fa-user-plus"></i></span>
            <div class="aps-title">
              <h5>إضافة الطلاب</h5>
              <small>كيف يضيف ولي الأمر ابنه في التطبيق.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row">
              <span>السماح لأولياء الأمور بإضافة الطلاب</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_add_students" @change="set('no_add_students', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <label class="aps-row">
              <span>طلب رقم الجوال عند الإضافة <small>يُضاف الطالب فقط إذا طابق الرقم المسجل في حسابه.</small></span>
              <span class="aps-switch"><input type="checkbox" :checked="!!settings.require_phone" @change="set('require_phone', $event.target.checked ? 'yes' : false)"><span></span></span>
            </label>
          </div>
        </section>

        <!-- ما يظهر لولي الأمر -->
        <section class="aps-card">
          <header>
            <span class="aps-ic violet"><i class="fa fa-id-card-o"></i></span>
            <div class="aps-title">
              <h5>ما يظهر لولي الأمر</h5>
              <small>أوقف أي خدمة لتختفي من صفحة الطالب في التطبيق.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row" v-for="f in features" :key="f.key">
              <span>{{ f.label }}</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings[f.key]" @change="set(f.key, $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <div class="aps-sub">في سجل حضور الطالب</div>
            <label class="aps-row" v-for="f in statuses" :key="f.key">
              <span>{{ f.label }}</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings[f.key]" @change="set(f.key, $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
          </div>
        </section>

        <!-- المحادثات -->
        <section class="aps-card">
          <header>
            <span class="aps-ic sky"><i class="fa fa-comments-o"></i></span>
            <div class="aps-title">
              <h5>المحادثات</h5>
              <small>مع من يستطيع ولي الأمر التواصل.</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row">
              <span>التواصل مع المعلمين</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_chat_teachers" @change="set('no_chat_teachers', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
            <label class="aps-row">
              <span>التواصل مع الإدارة</span>
              <span class="aps-switch"><input type="checkbox" :checked="!settings.no_chat_admin" @change="set('no_chat_admin', $event.target.checked ? false : 'yes')"><span></span></span>
            </label>
          </div>
        </section>

        <section class="aps-card" v-if="settings.notify">
          <header>
            <div class="aps-title">
              <h5>إشعارات تطبيق ولي الأمر</h5>
              <small>تحكّم في أنواع الإشعارات التي تصل إلى جوال ولي الأمر عبر التطبيق. (رسائل الواتساب والجوال لا تتأثر.)</small>
            </div>
          </header>
          <div class="aps-body">
            <label class="aps-row">
              <span><b>تفعيل إشعارات الجوال لأولياء الأمور</b></span>
              <span class="aps-switch"><input type="checkbox" :checked="settings.notify.all" @change="toggleNotify('all', $event.target.checked)"><span></span></span>
            </label>
            <label class="aps-row" v-for="n in notifyTypes" :key="n.key" :class="{ disabled: !settings.notify.all }">
              <span>{{ n.label }} <small class="text-muted">— {{ n.hint }}</small></span>
              <span class="aps-switch" :class="{ disabled: !settings.notify.all }"><input type="checkbox" :disabled="!settings.notify.all" :checked="settings.notify.all && settings.notify[n.key]" @change="toggleNotify(n.key, $event.target.checked)"><span></span></span>
            </label>
          </div>
        </section>
      </div>
    </div>

    <div class="aps-save" v-if="loaded">
      <span class="state" :class="{ dirty: dirty }">
        <i class="fa" :class="dirty ? 'fa-circle' : 'fa-check-circle'"></i>
        {{ dirty ? 'لديك تغييرات غير محفوظة' : 'كل التغييرات محفوظة' }}
      </span>
      <button class="btn btn-primary" @click="save()" :disabled="saving">
        <i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
        حفظ الإعدادات{{ newAd && sendNotification ? ' وإرسال الإشعار' : '' }}
      </button>
    </div>

    <!-- من حمّل التطبيق ومن لم يحمّله -->
    <b-modal id="app-status" title="من حمّل التطبيق ومن لم يحمّله" size="lg" hide-footer>
      <div class="text-center g" v-if="app.loading">
        <img :src="require('@/assets/images/loading.svg')" alt="" width="50">
      </div>
      <div v-else>
        <div class="as-tabs">
          <button type="button" class="as-tab yes" :class="{ on: app.tab == 'yes' }" @click="app.tab = 'yes'">
            <i class="fa fa-check-circle"></i> حمّلوا التطبيق ({{ appCounts.yes }})
          </button>
          <button type="button" class="as-tab no" :class="{ on: app.tab == 'no' }" @click="app.tab = 'no'">
            <i class="fa fa-times-circle"></i> لم يحمّلوا التطبيق ({{ appCounts.no }})
          </button>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-1">
            <label for="as-classname">الصف</label>
            <select id="as-classname" class="form-control" v-model="app.classname" @change="app.classroom = ''">
              <option value="">الكل</option>
              <option v-for="c in appGrades" :key="c.title" :value="c.title">{{ c.title }}</option>
            </select>
          </div>
          <div class="col-12 col-md-4 mb-1">
            <label for="as-classroom">الفصل</label>
            <select id="as-classroom" class="form-control" v-model="app.classroom" :disabled="!app.classname">
              <option value="">{{ app.classname ? 'الكل' : '-- اختر الصف اولاً --' }}</option>
              <option v-for="c in appClassrooms" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-12 col-md-4 mb-1">
            <label for="as-q">بحث</label>
            <input id="as-q" type="text" class="form-control" v-model="app.q" placeholder="اسم الطالب أو الهوية أو الجوال...">
          </div>
        </div>

        <div class="as-actions">
          <span class="text-muted small">{{ appRows.length }} طالب</span>
          <span>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="printApp()" :disabled="!appRows.length">
              <i class="fa fa-print"></i> طباعة
            </button>
            <button type="button" class="btn btn-sm btn-outline-success" @click="exportApp()" :disabled="!appRows.length">
              <i class="fa fa-file-excel-o"></i> تصدير Excel
            </button>
          </span>
        </div>

        <div class="table-responsive as-table">
          <table class="table table-sm table-hover table-bordered mb-0" id="app-status-table">
            <thead>
              <tr>
                <th>م</th>
                <th>الطالب</th>
                <th>الصف</th>
                <th>الفصل</th>
                <th>جوال ولي الأمر</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, i) in appRows" :key="s._id">
                <td>{{ i + 1 }}</td>
                <td>{{ s.name }}</td>
                <td>{{ s.classname }}</td>
                <td>{{ s.classroom }}</td>
                <td>{{ s.phones.length ? s.phones.join('، ') : '—' }}</td>
              </tr>
              <tr v-if="!appRows.length">
                <td colspan="5" class="text-center text-muted">لا يوجد طلاب.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <small class="text-muted d-block mt-1">
          «حمّلوا التطبيق»: أضاف ولي الأمر ابنه في تطبيق ولي الأمر، حتى لو أوقف الإشعارات في جواله.
          <template v-if="app.tab == 'no' && checkPer('students|students|send')">
            ولإرسال رسالة SMS أو واتساب لمن لم يحمّله: من صفحة
            <router-link to="/students-messages" @click.native="$bvModal.hide('app-status')">ارسال رسائل للطلاب</router-link>
            اختر «من لم يحمل التطبيق».
          </template>
        </small>
      </div>
    </b-modal>
  </div>
</template>

<script>
var XLSX = require("xlsx");
import { BModal, VBModal } from "bootstrap-vue";
import { reqPost, settingsOf, withDefaults, errorText, WEEKDAYS } from "@/libs/parent-requests";

// app_settings fields kept as they come (the loop in created() turns the others into 'yes' / false)
const KEEP = ['ads', 'dismissal_time', 'notify', 'dismissal_mode', 'dismissal_days', 'dismissal_dates', 'dismissal_skip_holidays', 'dismissal_note'];
const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;
function riyadhToday(){
  try { return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Riyadh' }); } catch(e) { return new Date().toISOString().split('T')[0]; }
}

// "صفحة المدرسة" features the parent app hides when `no_<key>` is 'yes' (switch on = shown).
const FEATURES = [
  { key: 'no_calls', label: 'نظام المناداة' },
  { key: 'no_full_report', label: 'التقرير الشامل' },
  { key: 'no_report', label: 'تقرير الحضور والغياب' },
  { key: 'no_points', label: 'نقاط التقييم' },
  { key: 'no_health', label: 'الملاحظات الصحية' },
  { key: 'no_bis', label: 'المخالفات السلوكية' },
  { key: 'no_breaks', label: 'المواقف الطارئة' },
  { key: 'no_visits', label: 'الزيارات' },
  { key: 'no_tasks', label: 'المهام' },
];
const STATUSES = [
  { key: 'no_status_1', label: 'أيام الحضور' },
  { key: 'no_status_2', label: 'أيام التأخر' },
  { key: 'no_status_3', label: 'أيام الغياب' },
];

export default {
  components: {
    BModal,
  },
  directives: {
    "b-modal": VBModal,
  },
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      // «من حمّل التطبيق ومن لم يحمّله»: rows of /user/push/app-status (has_app, never the token).
      app: { loading: false, list: [], tab: 'yes', classname: '', classroom: '', q: '' },
      settings: { ads: [] },
      loaded: false,
      saving: false,
      sendNotification: true,
      originalAdIds: [],
      saved: '',
      features: FEATURES,
      statuses: STATUSES,
      notifyTypes: [
        { key: 'ghiab', label: 'الغياب والحضور', hint: 'إشعار تسجيل الغياب / الحضور / التأخر' },
        { key: 'bis', label: 'المخالفات السلوكية', hint: 'إشعار تسجيل مخالفة للطالب' },
        { key: 'chat', label: 'المحادثات', hint: 'رسائل المدرسة والمعلمين لولي الأمر' },
        { key: 'rate', label: 'التقييمات', hint: 'إشعار إضافة تقييم للطالب' },
        { key: 'task', label: 'المهام والواجبات', hint: 'إشعار إضافة مهمة أو واجب' },
        { key: 'call', label: 'المناداة والانصراف', hint: 'إشعار مناداة الطالب للخروج' },
        { key: 'news', label: 'الأخبار والتنبيهات', hint: 'الأخبار ورسائل المدرسة العامة' },
      ],
      quickTimes: ['11:00', '11:30', '12:00', '12:30', '13:00', '13:30'],
      date: new Date().toISOString().split('T')[0],
      // موعد الخروج (part C)
      dismissalModes: [
        { key: 'fixed', title: 'نفس الموعد كل يوم', hint: 'من الأحد إلى الخميس', icon: 'fa-clock-o' },
        { key: 'weekly', title: 'موعد مختلف لكل يوم', hint: 'لكل يوم وقته', icon: 'fa-calendar' },
        { key: 'off', title: 'إخفاء الموعد', hint: 'لا يظهر في التطبيق', icon: 'fa-eye-slash' },
      ],
      allDays: WEEKDAYS,
      weekDays: WEEKDAYS.slice(0, 5),
      otherDays: WEEKDAYS.slice(5),
      showOtherDays: false,
      today: riyadhToday(),
      // طلبات أولياء الأمور: its own Option, saved with the same button
      pr: { supported: false, loading: true, s: withDefaults(null), saved: '' },
      leaveOptions: [
        { key: 'call', title: 'مناداة الطالب في نظام المناداة', hint: 'يحتاج خدمة المناداة.' },
        { key: 'leave_record', title: 'تسجيل استئذان (انصراف)', hint: 'يُسجَّل في تقرير اليوم ويُبلَّغ ولي الأمر كالمعتاد.' },
        { key: 'teachers', title: 'إبلاغ معلمي الطالب', hint: '«إذن خروج من المدرسة» في تطبيق المعلم.' },
      ],
    }
  },
  computed: {
    dirty(){
      return this.loaded && (JSON.stringify(this.settings) != this.saved || this.prDirty);
    },
    prDirty(){
      return this.pr.supported && JSON.stringify(this.pr.s) != this.pr.saved;
    },
    otherDaysSet(){
      var d = this.settings.dismissal_days || {};
      return !!(d.Friday || d.Saturday);
    },
    pastExceptions(){
      var t = this.today;
      return (this.settings.dismissal_dates || []).filter(function(x){ return x.date && x.date < t }).length;
    },
    // what the parent app shows today, by the server's order: a date exception > the mode (holidays are checked by the server)
    todayPill(){
      var s = this.settings, t = this.today;
      var ex = (s.dismissal_dates || []).filter(function(x){ return x.date == t })[0];
      var dayKey = this.dayKey(t);
      if(ex){
        return ex.time
          ? { time: ex.time, note: ex.note || s.dismissal_note, src: 'من استثناء هذا التاريخ' }
          : { why: 'مخفي في هذا التاريخ' + (ex.note ? ' (' + ex.note + ')' : ''), src: '' };
      }
      if(s.dismissal_mode == 'off') return { why: 'الموعد مخفي' };
      if(s.dismissal_mode == 'weekly'){
        var v = (s.dismissal_days || {})[dayKey];
        return v ? { time: v, note: s.dismissal_note, src: 'من موعد يوم ' + this.dayTitle(t) } : { why: 'لا يوجد موعد يوم ' + this.dayTitle(t) };
      }
      if(dayKey == 'Friday' || dayKey == 'Saturday') return { why: 'لا يظهر يوم ' + this.dayTitle(t) };
      if(!s.dismissal_time) return { why: 'لم يُحدَّد موعد' };
      if(s.dismissal_show != 'yes') return { why: 'الموعد مخفي' };
      return { time: s.dismissal_time, note: s.dismissal_note, src: '' };
    },
    // The first news added since the last save: its title is the notification.
    newAd(){
      var originals = this.originalAdIds;
      return (this.settings.ads || []).find(function(a){
        return a && a.id && originals.indexOf(a.id) === -1 && (a.title || a.content);
      }) || null;
    },
    // Grades in the order they come in the school's student list, classes by number inside each.
    appGrades(){
      var out = [];
      this.app.list.forEach(function(s){
        var g = out.find(function(x){ return x.title == s.classname });
        if(!g) out.push(g = { title: s.classname, classrooms: [] });
        if(g.classrooms.indexOf(s.classroom) === -1) g.classrooms.push(s.classroom);
      });
      out.forEach(function(g){
        g.classrooms.sort(function(a, b){ return String(a ?? '').localeCompare(String(b ?? ''), 'ar', { numeric: true }) });
      });
      return out;
    },
    appClassrooms(){
      var c = this.app.classname;
      var g = this.appGrades.find(function(x){ return x.title == c });
      return g ? g.classrooms : [];
    },
    // Class and search filters (both tabs), sorted by grade then class, the school's order inside.
    appFiltered(){
      var a = this.app, q = a.q.trim(), grades = this.appGrades.map(function(g){ return g.title });
      return a.list.filter(function(s){
        if(a.classname && s.classname != a.classname) return false;
        if(a.classroom && s.classroom != a.classroom) return false;
        if(q && !(s.name || '').includes(q) && !String(s.number || '').includes(q) && !s.phones.join(',').includes(q)) return false;
        return true;
      }).sort(function(x, y){
        return grades.indexOf(x.classname) - grades.indexOf(y.classname)
          || String(x.classroom ?? '').localeCompare(String(y.classroom ?? ''), 'ar', { numeric: true });
      });
    },
    appCounts(){
      var yes = this.appFiltered.filter(function(s){ return s.has_app }).length;
      return { yes: yes, no: this.appFiltered.length - yes };
    },
    appRows(){
      var want = this.app.tab == 'yes';
      return this.appFiltered.filter(function(s){ return s.has_app === want });
    },
    appTitle(){
      var a = this.app;
      return (a.tab == 'yes' ? 'حمّلوا التطبيق' : 'لم يحمّلوا التطبيق')
        + (a.classname ? ' - ' + a.classname + (a.classroom ? ' - ' + a.classroom : '') : '');
    },
  },
  created(){
    if(!checkPer("app-settings")){
      this.$router.push('/NotPermitted')
      return false;
    }
    var g = this;
    $.post(api + '/user/general/settings/app-settings', {
      jwt: this.user.jwt
    }).then(function(r){
      var s = r.response || {};
      for (const [key, value] of Object.entries(s)) {
        // objects / arrays (and the fields above) stay as they are; a switch is 'yes' or false
        if(KEEP.indexOf(key) === -1 && !(value && typeof value == 'object')){
          s[key] = value == 'yes' ? 'yes' : false
        }
      }
      if(!Array.isArray(s.ads)) s.ads = [];
      if(typeof s.dismissal_time != 'string') s.dismissal_time = '';
      if(s.dismissal_show === undefined) s.dismissal_show = false;
      g.normalizeDismissal(s);
      // إشعارات تطبيق ولي الأمر: كل نوع مُفعّل افتراضياً (المفتاح الغائب = ON)، فنبدأها بالقيم المخزّنة فوق الافتراضي
      var storedNotify = (s.notify && typeof s.notify == 'object') ? s.notify : {};
      s.notify = { all: storedNotify.all !== false };
      ['ghiab','bis','chat','rate','task','call','news'].forEach(function(t){
        s.notify[t] = storedNotify[t] !== false;
      });
      g.settings = s
      g.originalAdIds = s.ads.map(function(a){ return a.id }).filter(function(x){ return x })
      g.saved = JSON.stringify(s)
      g.loaded = true
      g.$nextTick(function(){ g.goHash() })
    })
    g.loadPr();
  },
  methods: {
    set(key, value){
      this.$set(this.settings, key, value);
    },
    // ------------------------------------------------ موعد الخروج (part C)
    normalizeDismissal(s){
      if(['fixed', 'weekly', 'off'].indexOf(s.dismissal_mode) === -1) s.dismissal_mode = 'fixed';
      var days = (s.dismissal_days && typeof s.dismissal_days == 'object' && !Array.isArray(s.dismissal_days)) ? s.dismissal_days : {};
      var out = {};
      WEEKDAYS.forEach(function(d){ out[d.key] = HHMM.test(days[d.key] || '') ? days[d.key] : '' });
      s.dismissal_days = out;
      s.dismissal_dates = (Array.isArray(s.dismissal_dates) ? s.dismissal_dates : []).filter(function(x){ return x && typeof x == 'object' }).map(function(x){
        return { date: typeof x.date == 'string' ? x.date : '', time: HHMM.test(x.time || '') ? x.time : '', note: typeof x.note == 'string' ? x.note : '' };
      });
      s.dismissal_skip_holidays = s.dismissal_skip_holidays == 'no' ? 'no' : 'yes';
      if(typeof s.dismissal_note != 'string') s.dismissal_note = '';
    },
    setMode(m){
      var s = this.settings;
      // the first time «موعد مختلف لكل يوم» is picked: Sunday–Thursday start from the fixed time
      if(m == 'weekly' && s.dismissal_time && !WEEKDAYS.some(function(d){ return s.dismissal_days[d.key] })){
        this.weekDays.forEach(function(d){ s.dismissal_days[d.key] = s.dismissal_time });
      }
      this.set('dismissal_mode', m);
    },
    setDay(key, v){
      this.$set(this.settings.dismissal_days, key, v || '');
    },
    copySunday(){
      var s = this.settings, v = s.dismissal_days.Sunday;
      this.weekDays.forEach(function(d){ s.dismissal_days[d.key] = v });
    },
    dayKey(date){
      if(!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) return '';
      return WEEKDAYS[new Date(date + 'T12:00:00Z').getUTCDay()].key;
    },
    dayTitle(date){
      var k = this.dayKey(date);
      var d = WEEKDAYS.filter(function(x){ return x.key == k })[0];
      return d ? d.title : '';
    },
    addException(){
      var s = this.settings;
      if(s.dismissal_dates.length >= 120) return;
      s.dismissal_dates.push({ date: '', time: s.dismissal_time || '', note: '' });
    },
    exceptionTime(x, on){
      x.time = on ? (x.time || this.settings.dismissal_time || '12:00') : '';
    },
    removePastExceptions(){
      var t = this.today;
      this.settings.dismissal_dates = this.settings.dismissal_dates.filter(function(x){ return !x.date || x.date >= t });
    },
    // the exceptions as the server wants them: a date each, HH:MM or '' (hide), sorted; null + a message when wrong
    checkDismissal(){
      var s = this.settings;
      if(s.dismissal_dates.some(function(x){ return !/^\d{4}-\d{2}-\d{2}$/.test(x.date || '') })) return 'حدد التاريخ لكل استثناء في «موعد الخروج» أو احذفه.';
      var seen = {};
      for(var i = 0; i < s.dismissal_dates.length; i++){
        var d = s.dismissal_dates[i].date;
        if(seen[d]) return 'التاريخ ' + d + ' مكرر في استثناءات موعد الخروج.';
        seen[d] = true;
      }
      if(s.dismissal_mode == 'weekly' && !WEEKDAYS.some(function(d){ return s.dismissal_days[d.key] })) return 'حدد وقت الخروج ليوم واحد على الأقل، أو اختر «إخفاء الموعد».';
      s.dismissal_dates.sort(function(a, b){ return a.date.localeCompare(b.date) });
      s.dismissal_note = (s.dismissal_note || '').slice(0, 60);
      return '';
    },
    // ------------------------------------------------ طلبات أولياء الأمور
    loadPr(){
      var g = this;
      reqPost('/settings', {}, { global: false }).then(function(r){
        g.pr.loading = false;
        if(!r || r.status != 100) return;
        g.pr.s = withDefaults(settingsOf(r) || {});
        g.pr.saved = JSON.stringify(g.pr.s);
        g.pr.supported = true;
        g.$nextTick(function(){ g.goHash() });
      }).catch(function(){
        g.pr.loading = false;
      });
    },
    toggleVisitDay(k){
      var days = (this.pr.s.visit.days || []).slice();
      var i = days.indexOf(k);
      if(i > -1) days.splice(i, 1); else days.push(k);
      this.pr.s.visit.days = WEEKDAYS.map(function(d){ return d.key }).filter(function(x){ return days.indexOf(x) > -1 });
    },
    checkPr(){
      var s = this.pr.s, l = s.leave, v = s.visit;
      var t = function(x){ return !x || HHMM.test(x) };
      if(!t(l.from) || !t(l.to) || !t(v.from) || !t(v.to)) return 'اكتب الأوقات بصيغة صحيحة في «طلبات أولياء الأمور».';
      l.days_ahead = Math.max(0, Math.min(30, parseInt(l.days_ahead, 10) || 0));
      v.min_days = Math.max(0, parseInt(v.min_days, 10) || 0);
      v.max_days = Math.max(0, parseInt(v.max_days, 10) || 0);
      if(v.enabled && v.min_days > v.max_days) return 'في طلبات الزيارة: أقل عدد أيام أكبر من أكثرها.';
      if(v.enabled && !(v.days || []).length) return 'اختر يوماً واحداً على الأقل للزيارة.';
      if(l.from && l.to && l.from >= l.to) return 'في طلبات الاستئذان: وقت البداية بعد وقت النهاية.';
      if(v.enabled && v.from && v.to && v.from >= v.to) return 'في طلبات الزيارة: وقت البداية بعد وقت النهاية.';
      return '';
    },
    // resolves '' (saved / nothing to save) or the error text
    savePr(){
      var g = this;
      if(!g.prDirty) return Promise.resolve('');
      var obj = JSON.parse(JSON.stringify(g.pr.s));
      return reqPost('/settings/save', { settings: obj, leave: obj.leave, visit: obj.visit }).then(function(r){
        if(!r || r.status != 100) return errorText(r);
        var back = settingsOf(r);
        if(back) g.pr.s = withDefaults(back);
        g.pr.saved = JSON.stringify(g.pr.s);
        return '';
      }).catch(function(){
        return 'تعذّر حفظ إعدادات طلبات أولياء الأمور';
      });
    },
    goHash(){
      if(window.location.hash != '#parent-requests' || !this.pr.supported || !this.loaded) return;
      var el = document.getElementById('parent-requests');
      if(el) el.scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    // إشعارات تطبيق ولي الأمر: true = مُفعّل، false = موقوف
    toggleNotify(key, checked){
      if(!this.settings.notify) this.$set(this.settings, 'notify', {});
      this.$set(this.settings.notify, key, !!checked);
    },
    setTime(t){
      var had = !!this.settings.dismissal_time;
      this.set('dismissal_time', t || '');
      // Picking a time for the first time shows it; clearing hides it.
      if(t && !had) this.set('dismissal_show', 'yes');
      if(!t) this.set('dismissal_show', false);
    },
    time12(t){
      var m = /^(\d{1,2}):(\d{2})/.exec(t || '');
      if(!m) return '';
      var h = parseInt(m[1]);
      return (h % 12 || 12) + ':' + m[2] + (h < 12 ? ' ص' : ' م');
    },
    isNew(ad){
      return this.originalAdIds.indexOf(ad.id) === -1;
    },
    addAd(){
      var id = Math.random().toString();
      this.settings.ads.unshift({
        title: '',
        content: '',
        date: this.date,
        url: '',
        image: '',
        important: false,
        id: id
      });
      this.$nextTick(function(){
        var el = document.getElementById('ad-title-' + id);
        if(el) el.focus();
      });
    },
    removeAd(ad){
      if((ad.title || ad.content) && !confirm('حذف الخبر «' + (ad.title || 'بدون عنوان') + '»؟')) return;
      this.settings.ads = this.settings.ads.filter(function(x){ return x.id != ad.id });
    },
    save(){
      var g = this;
      var bad = g.checkDismissal() || (g.pr.supported ? g.checkPr() : '');
      if(bad){
        alert(bad, 200);
        return;
      }
      var notifyAd = g.sendNotification && g.newAd ? {
        title: g.newAd.title || '',
        content: g.newAd.content || ''
      } : null;
      g.saving = true;
      $.post(api + '/user/general/settings/app-settings/save', {
        jwt: this.user.jwt,
        object: JSON.stringify(g.settings)
      }).then(function(r){
        g.saving = false
        if(r.status != 100){
          alert(r.response)
          return;
        }
        g.originalAdIds = (g.settings.ads || []).map(function(a){ return a.id }).filter(function(x){ return x })
        g.saved = JSON.stringify(g.settings)
        // «طلبات أولياء الأمور» is its own Option: saved after, its error added to the message below
        g.savePr().then(function(prError){
        var prNote = prError ? " — ولم تُحفظ إعدادات طلبات أولياء الأمور: " + prError : "";
        if(notifyAd){
          $.post(api + '/user/general/settings/app-settings/notify', {
            jwt: g.user.jwt,
            title: notifyAd.title,
            body: notifyAd.content
          }).then(function(rr){
            if(rr.status == 100){
              alert("تم الحفظ وإرسال الإشعار إلى " + (rr.response || 0) + " من أولياء الأمور" + prNote, prError ? 200 : 100)
            }else{
              alert("تم الحفظ ولكن فشل إرسال الإشعار" + prNote, 200)
            }
          }).fail(function(){
            alert("تم الحفظ ولكن فشل الاتصال بخادم الإشعارات" + prNote, 200)
          })
        }else{
          alert("تم الحفظ" + prNote, prError ? 200 : 100)
        }
        })
      }).fail(function(){
        g.saving = false
        alert("حدث خطأ في الاتصال", 200)
      })
    },
    uploadImage(event, ad){
      var g = this;
      var file = event.target.files && event.target.files[0];
      if(!file) return;
      var formData = new FormData();
      formData.append("file", file, file.name);
      formData.append("jwt", g.user.jwt);
      $.ajax({
        type: "POST",
        url: api + '/user/general/upload',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        success: function(data){
          if(data.status != 100){
            alert("هذا الملف غير مدعوم", 200)
            return;
          }
          g.$set(ad, 'image', data.response)
        },
        error: function(){
          alert("حدث خطأ في رفع الصورة", 200)
        }
      })
      event.target.value = '';
    },
    // Loaded each time the window opens, so it is up to date; the filters stay as they were.
    loadApp(){
      var g = this;
      g.app.loading = true;
      $.post(api + '/user/push/app-status', {
        jwt: this.user.jwt
      }).then(function(r){
        g.app.loading = false
        if(r.status != 100){
          alert(r.response, 200)
          return;
        }
        g.app.list = r.response
      }).fail(function(){
        g.app.loading = false
        alert("حدث خطأ في الاتصال", 200)
      })
    },
    printApp(){
      var table = document.getElementById('app-status-table');
      if(!table) return;
      var esc = function(t){ return $('<div>').text(t || '').html() };
      var newWin = window.open("");
      newWin.document.write(`
      <html dir="rtl">
      <head>
      <meta charset="utf-8">
      <title>${esc(this.appTitle)}</title>
      <style>
      html, body{
          direction: rtl;
          font-family: Arial;
      }
      table, td, th {
          border: 1px solid;
          padding: 4px;
      }
      table {
          width: 100%;
          border-collapse: collapse;
      }
      </style>
      </head>
      <body>
      <h3>${esc(this.user.name)}</h3>
      <h4>${esc(this.appTitle)} (${this.appRows.length} طالب)${this.app.q.trim() ? ' - بحث: ' + esc(this.app.q.trim()) : ''}</h4>
      ` + table.outerHTML + `
      </body>
      </html>`);
      newWin.document.close()
      newWin.print();
    },
    exportApp(){
      var rows = this.appRows.map(function(s, i){
        return [i + 1, s.name, s.number, s.classname, s.classroom, s.phones.join(", ")]
      });
      var ws = XLSX.utils.aoa_to_sheet([["م", "الطالب", "الهوية", "الصف", "الفصل", "جوال ولي الأمر"]].concat(rows));
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Records');
      XLSX.writeFile(wb, this.appTitle + ".xlsx");
    },
  }
}
</script>

<style scoped>
.aps {
  padding-bottom: 84px;
}
.aps-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}
.aps-head-text {
  flex: 1;
  min-width: 220px;
}
.aps-head-btn {
  border-radius: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.aps-head-icon {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 24px;
  color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  flex-shrink: 0;
}
.aps-head h4 {
  margin: 0 0 2px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
}
.aps-head p {
  margin: 0;
  color: var(--sk-muted, #667085);
  font-size: 13px;
}
.aps-card {
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 16px;
  box-shadow: var(--sk-shadow, none);
  margin-bottom: 16px;
  overflow: hidden;
}
.aps-card > header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--sk-line, #D5DAE3);
}
.aps-title {
  flex: 1;
  min-width: 0;
}
.aps-title h5 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--sk-ink, #0F1733);
}
.aps-title small {
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.aps-title .count {
  display: inline-block;
  min-width: 22px;
  padding: 0 7px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 20px;
  text-align: center;
  background: var(--sk-ps, #E8EEFD);
  color: var(--sk-p, #1D4ED8);
  margin-inline-start: 4px;
}
.aps-ic {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  font-size: 17px;
  flex-shrink: 0;
}
.aps-ic.red { background: var(--sk-bads, #FEE4E2); color: var(--sk-badi, #B42318); }
.aps-ic.blue { background: var(--sk-ps, #E8EEFD); color: var(--sk-p, #1D4ED8); }
.aps-ic.green { background: var(--sk-oks, #DCFAE6); color: var(--sk-oki, #067647); }
.aps-ic.violet { background: #EEEAFD; color: #5B3FD6; }
.aps-ic.sky { background: var(--sk-ins, #E0F2FE); color: var(--sk-ini, #026AA2); }
.aps-body {
  padding: 14px 16px;
}

/* switches */
.aps-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
  user-select: none;
}
.aps-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.aps-switch > span {
  width: 40px;
  height: 22px;
  border-radius: 999px;
  background: var(--sk-field, #BFC6D1);
  position: relative;
  transition: background .15s;
}
.aps-switch > span::after {
  content: '';
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
  transition: transform .15s;
}
.aps-switch input:checked + span {
  background: var(--sk-p, #1D4ED8);
}
[dir="rtl"] .aps-switch input:checked + span::after {
  transform: translateX(-18px);
}
[dir="ltr"] .aps-switch input:checked + span::after {
  transform: translateX(18px);
}
.aps-switch input:focus-visible + span {
  outline: 2px solid var(--sk-p, #1D4ED8);
  outline-offset: 2px;
}
.aps-switch b {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--sk-text, #344054);
}
.aps-switch.disabled {
  opacity: .5;
  cursor: not-allowed;
}
.aps-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  margin: 0;
  cursor: pointer;
  border-bottom: 1px dashed var(--sk-line, #D5DAE3);
  color: var(--sk-text, #344054);
  font-size: 13.5px;
}
.aps-row:last-child {
  border-bottom: 0;
}
.aps-row small {
  display: block;
  color: var(--sk-muted, #667085);
  font-size: 11.5px;
}
.aps-sub {
  margin: 12px 0 2px;
  font-size: 12px;
  font-weight: 700;
  color: var(--sk-muted, #667085);
}

/* dismissal time */
.dismissal {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}
.dismissal-field label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 4px;
}
.dismissal-field input {
  width: 150px;
  font-weight: 700;
  font-size: 16px;
  direction: ltr;
  text-align: center;
}
.quick {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--sk-muted, #667085);
}
.chip {
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  color: var(--sk-text, #344054);
  border-radius: 999px;
  padding: 3px 11px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.chip:hover {
  border-color: var(--sk-p, #1D4ED8);
}
.chip.on {
  background: var(--sk-ps, #E8EEFD);
  border-color: var(--sk-p, #1D4ED8);
  color: var(--sk-p, #1D4ED8);
}
.chip.clear {
  color: var(--sk-badi, #B42318);
}
.preview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sk-soft, #F6F7FB);
  font-size: 13px;
}
.preview-label {
  color: var(--sk-muted, #667085);
  font-size: 12px;
}
.dismissal-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--sk-bads, #FEE4E2);
  color: var(--sk-badi, #B42318);
  font-size: 12.5px;
  font-weight: 600;
}

/* news */
.notify {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border-radius: 12px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-soft, #F6F7FB);
  margin-bottom: 12px;
  font-size: 13px;
  color: var(--sk-text, #344054);
}
.notify.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
}
.notify small {
  color: var(--sk-muted, #667085);
}
.empty {
  text-align: center;
  color: var(--sk-muted, #667085);
  margin: 6px 0;
  font-size: 13px;
}
.ad {
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 14px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 9px;
}
.ad + .ad {
  margin-top: 10px;
}
.ad.fresh {
  border-color: var(--sk-p, #1D4ED8);
}
.ad-top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ad-title {
  font-weight: 700;
}
.badge-new {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--sk-p, #1D4ED8);
  color: #fff;
}
.icon-btn {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: transparent;
  cursor: pointer;
}
.icon-btn.danger {
  color: var(--sk-badi, #B42318);
}
.icon-btn.danger:hover {
  background: var(--sk-bads, #FEE4E2);
}
.ad-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
}
.ad-image {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ad-image img {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--sk-line, #D5DAE3);
}
.ad-action {
  flex: 1;
  min-width: 180px;
}
.ad-action label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 3px;
}
.small-sw b {
  font-size: 12px;
}
.ltr {
  direction: ltr;
  text-align: left;
}

/* save bar */
.aps-save {
  position: sticky;
  bottom: 12px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  border-radius: 14px;
  background: var(--sk-card, #fff);
  border: 1px solid var(--sk-line, #D5DAE3);
  box-shadow: var(--sk-pop, 0 8px 24px rgba(0, 0, 0, .12));
}
.aps-save .state {
  font-size: 13px;
  color: var(--sk-oki, #067647);
}
.aps-save .state.dirty {
  color: var(--sk-wai, #B54708);
}
.aps-save .state .fa-circle {
  font-size: 9px;
  vertical-align: middle;
}

/* من حمّل التطبيق ومن لم يحمّله */
.as-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}
.as-tab {
  flex: 1;
  min-width: 180px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  color: var(--sk-text, #344054);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}
.as-tab.yes i { color: var(--sk-oki, #067647); }
.as-tab.no i { color: var(--sk-badi, #B42318); }
.as-tab.yes.on {
  background: var(--sk-oks, #DCFAE6);
  border-color: var(--sk-oki, #067647);
  color: var(--sk-oki, #067647);
}
.as-tab.no.on {
  background: var(--sk-bads, #FEE4E2);
  border-color: var(--sk-badi, #B42318);
  color: var(--sk-badi, #B42318);
}
.as-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 4px 0 8px;
}
.as-actions .btn + .btn {
  margin-inline-start: 6px;
}
.as-table {
  min-height: 0;
  max-height: 55vh;
  overflow-y: auto;
}
.as-table th {
  position: sticky;
  top: 0;
  background: var(--sk-soft, #F6F7FB);
}
/* موعد الخروج: modes, weekdays, exceptions */
.aps-ic.amber { background: var(--sk-was, #FEF0C7); color: var(--sk-wai, #B54708); }
.dmode {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 14px;
}
.dmode-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 10px 8px;
  border-radius: 12px;
  border: 1px solid var(--sk-line, #D5DAE3);
  background: var(--sk-card, #fff);
  color: var(--sk-text, #344054);
  cursor: pointer;
  text-align: center;
}
.dmode-btn .fa {
  font-size: 18px;
  color: var(--sk-muted, #667085);
}
.dmode-btn b {
  font-size: 13px;
}
.dmode-btn small {
  font-size: 11px;
  color: var(--sk-muted, #667085);
}
.dmode-btn.on {
  border-color: var(--sk-p, #1D4ED8);
  background: var(--sk-ps, #E8EEFD);
  color: var(--sk-p, #1D4ED8);
  box-shadow: 0 0 0 1px var(--sk-p, #1D4ED8) inset;
}
.dmode-btn.on .fa {
  color: var(--sk-p, #1D4ED8);
}
.dweek {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dday {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 12px;
  background: var(--sk-soft, #F6F7FB);
}
.dday.off {
  opacity: .8;
}
.dday-name {
  width: 76px;
  font-weight: 700;
  font-size: 13px;
  color: var(--sk-ink, #0F1733);
}
.dday input {
  width: 140px;
  direction: ltr;
  text-align: center;
  font-weight: 700;
}
.dday-12 {
  font-size: 12px;
  color: var(--sk-muted, #667085);
}
.dmore {
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: var(--sk-p, #1D4ED8);
  font-weight: 600;
  font-size: 12.5px;
  padding: 4px 2px;
  cursor: pointer;
}
.dnote {
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sk-soft2, #EEF1F6);
  font-size: 13px;
}
.dex-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 16px 0 8px;
  padding-top: 12px;
  border-top: 1px dashed var(--sk-line, #D5DAE3);
}
.dex-head b {
  display: block;
  font-size: 13.5px;
  color: var(--sk-ink, #0F1733);
}
.dex-head small {
  color: var(--sk-muted, #667085);
  font-size: 11.5px;
}
.dex {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
  padding: 10px;
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 12px;
  margin-bottom: 8px;
}
.dex.past {
  opacity: .6;
}
.dex-f label {
  font-size: 11.5px;
  color: var(--sk-muted, #667085);
  margin-bottom: 3px;
  display: block;
}
.dex-f input[type="date"],
.dex-f input[type="time"] {
  width: 136px;
  direction: ltr;
}
.dex-f small {
  display: block;
  font-size: 11px;
  min-height: 14px;
}
.dex-f.grow {
  flex: 1;
  min-width: 120px;
}
.dex-seg {
  display: inline-flex;
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 10px;
  overflow: hidden;
}
.dex-seg button {
  border: 0;
  background: var(--sk-card, #fff);
  padding: 7px 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--sk-text, #344054);
  cursor: pointer;
}
.dex-seg button.on {
  background: var(--sk-p, #1D4ED8);
  color: #fff;
}
.dismissal-note {
  margin-top: 6px;
}
.dismissal-note label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 3px;
}
.preview-note {
  color: var(--sk-text, #344054);
}
.preview-src {
  color: var(--sk-muted, #667085);
  font-size: 11.5px;
}

/* طلبات أولياء الأمور */
.prs {
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 14px;
  padding: 2px 12px;
  margin-bottom: 12px;
}
.prs-head {
  border-bottom: 0;
}
.prs-head b .fa {
  color: var(--sk-muted, #667085);
  margin-inline-end: 4px;
}
.prs-body {
  border-top: 1px dashed var(--sk-line, #D5DAE3);
  padding: 10px 0 12px;
}
.prs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}
.prs-grid.two {
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  margin-top: 10px;
}
.prs-f label {
  font-size: 12px;
  color: var(--sk-muted, #667085);
  margin-bottom: 3px;
}
.prs-f input[type="time"],
.prs-f input[type="number"] {
  direction: ltr;
  text-align: center;
}
.prs-hint {
  display: block;
  margin-top: 4px;
  color: var(--sk-muted, #667085);
  font-size: 11.5px;
}
.prs-days {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
@media (max-width: 575.98px) {
  .dmode {
    grid-template-columns: 1fr;
  }
  .dmode-btn {
    flex-direction: row;
    gap: 8px;
    justify-content: flex-start;
  }
  .dex-f input[type="date"],
  .dex-f input[type="time"] {
    width: 100%;
  }
  .dex-f {
    flex: 1;
    min-width: 130px;
  }
}
</style>
